import React from 'react';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CtaContentCards } from '@ahc-digital/component-library';
import { CreateCTAContentCardsModel } from './C20CTAContentCards.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C20CTAContentCardsProps = RenderingProps<
  C20CTAContentCardsFields,
  {
    TitleType?: string;
    ContentAlignment?: string;
    NumberOfColumns?: string;
    BackgroundColor?: string;
    EnableDropshadow?: boolean;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;

export type C20CTAContentCardsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
  CTA?: LinkField;
};

export const Default = (props?: C20CTAContentCardsProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <CtaContentCards
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...CreateCTAContentCardsModel(props)}
    />
  );
};
